// store/middleware/paymentMethodsCacheMiddleware.ts
import { Middleware } from "@reduxjs/toolkit";
import { saveToStorage } from "../../common/utils/functions/localStorage";
import { getCacheVersion } from "../../config/runtimeConfig";

export const paymentMethodsCacheMiddleware: Middleware =
  (store) => (next) => (action: any) => {
    const result = next(action);

    if (action.type === "payment-methods/setPaymentMethods") {
      const paymentMethods = store.getState().paymentMethods.data;

      if (paymentMethods) {
        try {
          const version = getCacheVersion();
          const CACHE_KEY = `payment_methods_v${version}`;
          saveToStorage(CACHE_KEY, paymentMethods);
        } catch (error) {
          console.error("Ошибка сохранения кэша способов оплаты:", error);
        }
      }
    }

    return result;
  };